import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * HTTP Interceptor to attach JWT token to authenticated requests
 */
export const authInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const token = authService.getToken();

    // Clone request and add auth header if token exists
    let authReq = req;
    if (token) {
        authReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            // Handle 401 Unauthorized - redirect to login
            // Skip for logout endpoint to prevent infinite loop
            // Skip for public endpoints that can work without auth
            if (error.status === 401) {
                const url = req.url;
                const isLogoutRequest = url.includes('/user/logout');
                const isPublicBooking = url.includes('/user/bookings') && req.method === 'POST';

                if (!isLogoutRequest && !isPublicBooking && token) {
                    authService.logout();
                    router.navigate(['/auth/login']);
                }
            }
            return throwError(() => error);
        })
    );
};
